import React from 'react';
import numericFunction from "../../../utils/NumericFunction";
import commaSeparator from "../../../utils/CommaSeparator";

const ControlUnderTablePrint = (props) => {

  const initialData = props.data.data

  try {
    return (
      <div className="main-print-factor">
        <div className="header-side">
          <h4>{props.data.title}</h4>
        </div>

        <div className="box-top-side-review-accounts" style={{border: 'none'}}>

          <div className="box-top-side">

            <div className="name-side">
              <h3>{initialData?.shopName}</h3>
            </div>

            <div className="inline-text">
              <p>شماره سند :</p>
              <p>{numericFunction.e2p(initialData?.documentCode)}</p>
            </div>

            <div className="inline-text">
              <p>شـــرح سند :</p>
              <p>{numericFunction.e2p(initialData?.documentDescription)}</p>
            </div>

            <div className="inline-text">
              <p>شماره عطف :</p>
              <p>{numericFunction.e2p(initialData?.documentCode)}</p>
            </div>

            <div className="inline-text">
              <p>تاریـخ سند :</p>
              <p>{numericFunction.e2p(initialData?.documentDate)}</p>
            </div>

            <div className="inline-text">
              <p>شماره صفحه : :</p>
              <p>{numericFunction.e2p("1 از 1")}</p>
            </div>

          </div>

          <div className="table-accounting-document">

            <ul className="header-t-a-d">
              <li>
                <span style={{width: '5%', borderLeft: '0.25px solid #000'}}>ردیف</span>
                <span style={{width: '15%', borderLeft: '0.25px solid #000'}}>کد حساب</span>
                <span style={{width: '25%', borderLeft: '0.25px solid #000'}}>شرح</span>
                <span style={{width: '15%', borderLeft: '0.25px solid #000'}}>مبلغ جزء</span>
                <span style={{width: '40%'}}>مبلغ معین</span>
              </li>

              <li className="row-two">
                <span style={{width: '60%'}}></span>
                <span style={{
                  width: '20.2%',
                  borderRight: '0.25px solid #000',
                  borderLeft: '0.25px solid #000'
                }}>بدهکار</span>
                <span style={{width: '20%'}}>بستانکار</span>
              </li>
            </ul>

            <ul className="middle-t-a-d">
              {initialData?.documentDetails.length > 0 &&
                initialData?.documentDetails.map((v, index) =>
                  <li className="row-middle" key={"M" + index}>
                    <div className="level3-side">
                      <span style={{width: '5%'}}>{numericFunction.e2p(v.row)}</span>
                      <span style={{width: '15%'}}>{numericFunction.e2p(v.accountCode_3)}</span>
                      <span style={{width: '25%'}}>{v.accountCode_3}</span>
                      <span style={{width: '15%'}}></span>
                      <span style={{width: '20%'}}>{numericFunction.e2p(commaSeparator(v.bed))}</span>
                      <span style={{width: '20%'}}>{numericFunction.e2p(commaSeparator(v.bes))}</span>
                    </div>
                    {v.accountCodes.map((q) =>
                      <div className="level4-side">
                        <span style={{width: '5%'}}></span>
                        <span style={{width: '15%'}}>{numericFunction.e2p(q.value)}</span>
                        <span style={{width: '25%'}}>{q.label}</span>
                        <span
                          style={{width: '15%'}}>{numericFunction.e2p(commaSeparator(+q.bed !== 0 ? q.bed : q.bes))}</span>
                        <span style={{width: '20%'}}></span>
                        <span style={{width: '20%'}}></span>
                      </div>
                    )}
                  </li>
                )}
            </ul>

          </div>

          <div className="footer-t-a-d">

            {/*<div className="sum-foot">*/}
            {/*  <div style={{width: '60%', display: 'flex', justifyContent: 'flex-start'}}>*/}
            {/*    <p>جمع تا پایان صفحه</p>*/}
            {/*  </div>*/}
            {/*  <div className="two-price" style={{width: '40%'}}>*/}
            {/*    <p>{numericFunction.e2p(commaSeparator(initialData.sumOfBed))}</p>*/}
            {/*    <p>{numericFunction.e2p(commaSeparator(initialData.sumOfBes))}</p>*/}
            {/*  </div>*/}
            {/*</div>*/}

            <div className="box-side">
              <div className="box-footer">
                <p>صادر کننده :</p>
              </div>

              <div className="box-footer"
                   style={{borderLeft: '0.25px solid #000', borderRight: '0.25px solid #000'}}>
                <p>بررسی کننده :</p>
              </div>

              <div className="box-footer">
                <p>مدیرمالی :</p>
              </div>
            </div>

          </div>

        </div>
      </div>
    );
  } catch (error) {
    return <>{error.toLocaleString()}</>
  }
};

export default ControlUnderTablePrint;